import commonStyles from "../Common.module.css";
import Modal from "../Modal";

function DealScreenshotWarningModal({ onClose, onConfirm }: IDealScreenshotWarningModalProps) {
    return (
        <Modal header="Save without screenshot?" onClose={onClose}>
            Satellite screenshot is still loading. Are you sure you want to save without it?
            <div className={[commonStyles.modalControls, commonStyles.controlGroup].join(" ")}>
                <button className={commonStyles.secondaryButton} onClick={onClose}>Cancel</button>
                <button className={commonStyles.primaryButton} onClick={onConfirm}>Save</button>
            </div>
        </Modal>
    );
}

export default DealScreenshotWarningModal;

interface IDealScreenshotWarningModalProps {
    onClose: () => void;
    onConfirm: () => void;
}
